import { lazy } from 'react'
import { useAppShellLayoutContext } from '@/components/AppShell/AppShellLayoutContext'

const MainContentLayout = lazy(() => import('@/components/MainContentLayout'))
const DocumentsPage = lazy(() => import('@/pages/Documents/DocumentsPage'))
const ConnectionsPage = lazy(() => import('@/pages/Connections/ConnectionsPage'))

export function useShellLayout() {
  return /** @type {ReturnType<import('@/components/AppShell/useAppShellLayout').useAppShellLayout>} */ (
    useAppShellLayoutContext()
  )
}

export function HomeMainLayoutRoute() {
  const { mainLayoutProps } = useShellLayout()
  return <MainContentLayout {...mainLayoutProps} />
}

export function DocumentsMainLayoutRoute() {
  return (
    <MainContentLayout hideAskBar>
      <DocumentsPage />
    </MainContentLayout>
  )
}

export function ConnectionsMainLayoutRoute() {
  return <MainContentLayout hideAskBar><ConnectionsPage /></MainContentLayout>
}
